// ENG-5760: a signup that created the account but couldn't sign the user in
// hands them to the login form with this, so the form can say why they're there
// and prefill the email. On the /login route it rides in router state, which
// keeps the email out of the URL.
export interface SignInHandoff {
  email: string;
  notice: string;
}

// Router state is whatever the history entry holds, so check the shape.
export function readSignInHandoff(state: unknown): Partial<SignInHandoff> {
  if (typeof state !== 'object' || state === null) return {};
  const { email, notice } = state as Record<string, unknown>;
  return {
    email: typeof email === 'string' ? email : undefined,
    notice: typeof notice === 'string' ? notice : undefined,
  };
}
